import { flow, set } from 'lodash/fp';
import { Reducer } from 'redux';

import { LoginActionTypes } from '../../../../auth/login/store/types';
import { AdminAIChatbotActionTypes, AdminAIChatbotState } from './types';

const initialCustomDocumentQueryAnalytics = {
    totalQuestionsAsked: 0,
    totalQuestionsPassed: 0,
    questionsAskedPerDocumentNameType: {},
    questionsAskedPerClient: {}
};

export const INITIAL_STATE: AdminAIChatbotState = {
    isFetchingCustomQueryAnalytics: false,
    customDocumentQueryAnalytics: initialCustomDocumentQueryAnalytics
};

export const adminAIChatbotReducer: Reducer<AdminAIChatbotState> = (state = INITIAL_STATE, { payload, type }): AdminAIChatbotState => {
    switch (type) {
        case AdminAIChatbotActionTypes.FETCH_CUSTOM_QUERY_ANALYTICS_STARTED:
            return set('isFetchingCustomQueryAnalytics', true, state);
        case AdminAIChatbotActionTypes.FETCH_CUSTOM_QUERY_ANALYTICS_SUCCESSFUL:
            return flow(
                set('isFetchingCustomQueryAnalytics', false),
                set('customDocumentQueryAnalytics', payload)
            )(state);
        case AdminAIChatbotActionTypes.FETCH_CUSTOM_QUERY_ANALYTICS_FAILED:
            return set('isFetchingCustomQueryAnalytics', false, state);
        case LoginActionTypes.LOGOUT_SUCCESSFUL:
            return INITIAL_STATE;
        default:
            return state;
    }
};
